module.exports = __webpack_public_path__ + "img/logo_homealsok_blue.png";